export default function (name, args = {}) {
	window.dispatchEvent(
		new CustomEvent(name, {
			detail: args,
		})
	);
}
